import "./QuienesSomos.css";

import {
  FaAward,
  FaBuilding,
  FaChartLine,
  FaShieldAlt,
  FaUsers,
} from "react-icons/fa";

const valores = [
  {
    id: 1,
    icono: <FaShieldAlt />,
    titulo: "Calidad que perdura",
    texto:
      "Utilizamos materiales de primera y procesos constructivos de altos estándares.",
  },
  {
    id: 2,
    icono: <FaAward />,
    titulo: "Compromiso real",
    texto:
      "Cumplimos lo que prometemos, entregando confianza y tranquilidad.",
  },
  {
    id: 3,
    icono: <FaUsers />,
    titulo: "Experiencia y pasión",
    texto:
      "Un equipo profesional dedicado a crear hogares que mejoran la vida.",
  },
  {
    id: 4,
    icono: <FaChartLine />,
    titulo: "Inversión inteligente",
    texto:
      "Proyectos ubicados en zonas de crecimiento y alta valorización.",
  },
];

function QuienesSomos() {
  return (
    <section
      className="quienes-somos"
      id="nosotros"
    >
      {/* DECORACIONES */}

      <div className="about-decoration about-decoration-one"></div>
      <div className="about-decoration about-decoration-two"></div>

      <div className="quienes-somos-container">
        {/* PARTE SUPERIOR */}

        <div className="about-top">
          <div className="about-heading">
            <div className="about-label">
              <span></span>
              QUIÉNES SOMOS
            </div>

            <h2>
              Construimos espacios donde las familias
              <strong> construyen su futuro.</strong>
            </h2>

            <p>
              Diseñamos proyectos residenciales que combinan
              arquitectura, funcionalidad, seguridad y valor a
              largo plazo.
            </p>
          </div>

          {/* TARJETA DE EMPRESA */}

          <article className="about-brand-card">
            <div className="about-brand-icon">
              <FaBuilding />
            </div>

            <span>YANNA A&amp;P</span>

            <strong>CONSTRUCTIONS</strong>

            <div className="about-brand-line"></div>

            <small>
              Diseño, construcción y desarrollo residencial
              con visión de futuro.
            </small>
          </article>
        </div>

        {/* PARTE INFERIOR */}

        <div className="about-main">
          {/* DESCRIPCIÓN */}

          <article className="about-description">
            <span className="about-description-label">
              NUESTRA ESENCIA
            </span>

            <h3>
              Creamos hogares con propósito, identidad y
              excelencia.
            </h3>

            <p>
              YANNA A&amp;P CONSTRUCTIONS es una empresa
              dedicada al desarrollo de proyectos residenciales
              de alta calidad en la República Dominicana.
            </p>

            <p>
              Nos enfocamos en el diseño, construcción y entrega
              de espacios modernos, funcionales y seguros, con
              acabados premium y ubicaciones estratégicas que
              favorecen el confort y la valorización.
            </p>

            <div className="about-signature">
              <span></span>

              <p>
                Construcción con visión de futuro
              </p>
            </div>
          </article>

          {/* VALORES */}

          <div className="about-values">
            {valores.map((valor, index) => (
              <article
                className="about-value"
                key={valor.id}
              >
                <span className="about-value-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <div className="about-value-icon">
                  {valor.icono}
                </div>

                <div className="about-value-content">
                  <h3>{valor.titulo}</h3>

                  <p>{valor.texto}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default QuienesSomos;